'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var zIndex = [1, 2, 3, 4, 5, 6, 7, 8, 9];

exports.default = zIndex;
